
import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import useHtmlClass from '../../hooks/useHtmlClass';

const INIT_STATE = Map({
    activeUserContent: '',
    cartCount: 0,
    isLoggedIn: false
})

//TODO
function setActiveUserContent(state, action) {
    const [addHtmlClass, removeHtmlClass] = useHtmlClass()
      if(state.activeUserContent === '') {
        removeHtmlClass('navigation-is-active')
        return state.set('activeUserContent', action.payload.activeUserContent);
        
    } else if(state.activeUserContent === action.payload.activeUserContent) {
        removeHtmlClass('navigation-is-active')
        return state.set('activeUserContent', '');

    } else {
        addHtmlClass('navigation-is-active')
        return state.set('activeUserContent', action.payload.activeUserContent);
    }
}

function setLoggedIn(state, action){
    return state.set('isLoggedIn', action.payload.isLoggedIn);
}

export default function userbarReducer(state = INIT_STATE, action) {
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.UI_SET_ACTIVE_USER_CONTENT:
            return setActiveUserContent(state, action);
        case actionTypes.UI_SET_LOGGED_IN:
            return setLoggedIn(state, action);
        default:
            return state;
    }
}